import React, { useEffect, useState } from "react";

import "./stylesSportPerformance.css";

import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      beginAtZero: true,
      stacked: false,
    },
    y: {
      stacked: false,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    datalabels: {
      display: false,
      anchor: "end",
      align: "start",
      formatter: (value) => value.toLocaleString(),
      color: "black",
      font: {
        family: "Poppins-regular",
        weight: "bold",
      },
    },
    tooltip: {
      enabled: true,
      mode: "index",
      intersect: false,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US").format(value)}`;
        },
      },
    },
  },
};

function SportPerformance() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [isLoading, setIsLoading] = useState(false);

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("day")];
  const [dates, setDates] = useState(thisMonthRange);

  const [allDates, setAllDates] = useState([]);
  const [ggrData, setGgrData] = useState([]);
  const [turnoverData, setTurnoverData] = useState([]);

  const data = {
    labels: allDates,
    datasets: [
      {
        label: "Turnover",
        data: turnoverData,
        backgroundColor: "#E74C3C",
        borderRadius: 5,
      },
      {
        label: "GGR",
        data: ggrData,
        backgroundColor: "#6177E8",
        borderRadius: 5,
      },
    ],
  };

  const getSportPerformanceData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    const params = {
      start_date: startDate,
      end_date: endDate,
    };

    try {
      setIsLoading(true);
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_SPORT_PERFORMANCE_DATA,
        params
      );

      const data = response?.data?.data?.data;
      const ggrData = data.map((item) => item.ggr);
      const turnoverData = data.map((item) => item.turnover);

      const allDates = data.map((item) => item.date);

      setAllDates(allDates);
      setGgrData(ggrData);
      setTurnoverData(turnoverData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSportPerformanceData(dates, false);
  }, []);

  return (
    <div className="sport-performance-container">
      <div className="sport-performance-header">
        <h2>Sport Performance</h2>
        <CustomDatePicker
          getData={getSportPerformanceData}
          dates={dates}
          setDates={setDates}
          showPresets={true}
        />
      </div>

      <div className="sport-performance-chart">
        {isLoading ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
            <div className="sport-performance-types">
              <div className="sport-performance-type turnover">
                <div className="sport-performance-type-icon"></div>
                <span>Turnover</span>
              </div>
              <div className="sport-performance-type ggr">
                <div className="sport-performance-type-icon"></div>
                <span>GGR</span>
              </div>
            </div>
            <div className="sport-performance-chart-container">
              <Bar data={data} options={options} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SportPerformance;
